module.exports = __webpack_public_path__ + "static/media/store-header.9849d242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/store-header.jpg
// module id = 547
// module chunks = 0